import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import generate from 'firebase-auto-ids'
import { Modal } from 'wix-style-react'
import _ from 'lodash'

import { deleteTemporaryIntegrationData } from 'controllers/logic'
import * as integrationType from 'constants/integrationType'
import InstagramConnect from './instagramWizard/InstagramConnect'
import EcommerceConnect from './instagramWizard/EcommerceConnect'

class InstagramWizard extends Component {

  constructor (props) {
    super(props)

    const id = generate(_.now())

    this.state = {
      appName: '',
      selectedIntegration: null,
      isValid: false,
      errorMessage: '',
      appId: id,
      step: 0,
      instaName: null
    }
  }

  componentDidMount () {
    this.props.dispatch(deleteTemporaryIntegrationData())
  }

  handleCreateApp = () => {
    const { user } = this.props
    const { appId, appName, instaName } = this.state
    const integrationParams = _.get(user, ['temporaryIntegrationData', appId], {type: integrationType.SHOPIFY})
    const customFields = {
      appSettings: {
        instaName: instaName,
        integration: integrationParams
      }
    }
    this.props.handleCreateApp(appId, appName, customFields)
  }

  toNextStep = () => this.setState({step: this.state.step + 1})
  toPrevStep = () => this.setState({step: this.state.step - 1})
  onChangeInstaName = (v) => this.setState({instaName: v})
  onChangeAppName = (v) => this.setState({appName: v})
  onSelectIntegration = (iType) => this.setState({ selectedIntegration: iType })

  renderContent () {
    const { step, selectedIntegration, appId } = this.state
    const { handleCancel, templateId, user } = this.props
    switch (step) {
      case 0:
        return (
          <InstagramConnect
            handleCancel={handleCancel}
            toNextStep={this.toNextStep}
            instaName={this.state.instaName}
            onChangeInstaName={this.onChangeInstaName}
            onChangeAppName={this.onChangeAppName}
          />
        )
      case 1:
        return (
          <EcommerceConnect
            handleCancel={handleCancel}
            toPrevStep={this.toPrevStep}
            selectedIntegration={selectedIntegration}
            onSelectIntegration={this.onSelectIntegration}
            templateId={templateId}
            appId={appId}
            temporaryIntegrationData={user.temporaryIntegrationData}
            handleCreateApp={this.handleCreateApp}
          />
        )
    }
  }

  render () {
    return (
      <Modal zIndex={1000000} isOpen contentLabel=''>
        {this.renderContent()}
      </Modal>
    )
  }
}

InstagramWizard.propTypes = {
  templateId: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
  handleCreateApp: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => ({
  user: state.user,
})

export default connect(mapStateToProps)(InstagramWizard)



// WEBPACK FOOTER //
// ./src/components/dashboard/InstagramWizard.js